import React from "react";
import clsx from "clsx";

import styles from "./Micado.styles";

const Micado = () => {
	const css = styles();

	return (
		<div className={clsx(css.micado, "mco-view-component-footer-micado")}>
			<a href="https://www.micado.cc" target="_blank" rel="noreferrer" aria-label="Micado">
				<img alt="" height={33} loading="lazy" src="/img/micado.svg" width={99} />
			</a>
		</div>
	);
};

export default Micado;
